<div class="left">
  <div class="logo">
    <img src="assets/logo.png" alt="Logo" />
    <img src="assets/icons/android-icon-144x144.png" alt="Logo" class="small" />
  </div>
  <div class="textgroup" [@pageTransition]="currentStep">
    <h1 class="headline">{{ steps[currentStep].name | translate }}</h1>
  </div>
</div>
<div class="right">
  @if (currentStep > 0) {
  <qa-button
    [label]="'onboarding.previous' | translate"
    [isRaisedButton]="false"
    [icon]="'arrow_back'"
    (submitted)="previousStep()"
    [disabled]="switchingStep"
    class="back-button"
  ></qa-button>
  }
  <ng-scrollbar orientation="vetical">
    <div
      class="right-container"
      [class.card-section]="currentStep === OnboardingSteps.USE_CASES"
      [class.tour-section]="currentStep === OnboardingSteps.TOUR"
      [@pageTransition]="currentStep"
    >
      <ng-container *ngTemplateOutlet="rightContent"></ng-container>
    </div>
  </ng-scrollbar>
  @if (edition === 'dev' && currentStep < steps.length - 1) {
  <qa-button
    [label]="'onboarding.skipOnboarding' | translate"
    [isRaisedButton]="false"
    (submitted)="skipOnboarding()"
    [disabled]="switchingStep"
    class="skip-button"
  ></qa-button>
  }
</div>

<ng-template #rightContent>
  <div class="textgroup">
    @if (steps[currentStep]?.image) {
    <div class="head_image">
      <img [src]="steps[currentStep].image" alt="" />
    </div>
    }
    <h2
      class="headline"
      [innerHTML]="steps[currentStep].title | translate"
    ></h2>
    <p
      class="description"
      [innerHTML]="steps[currentStep].text | translate"
    ></p>
  </div>
  @if (currentStep === 0) {
  <ng-container *ngTemplateOutlet="firstStep"></ng-container>
  } @if (currentStep === 1) {
  <ng-container *ngTemplateOutlet="firstIntermediateStep"></ng-container>
  } @if (currentStep === 2) {
  <ng-container *ngTemplateOutlet="phoneNumberStep"></ng-container>
  }@if (currentStep === 3) {
  <ng-container *ngTemplateOutlet="secondStep"></ng-container>
  } @if (currentStep === 4) {
  <ng-container *ngTemplateOutlet="fourthStep"></ng-container>
  } @if (currentStep === 5) {
  <ng-container *ngTemplateOutlet="fifthStep"></ng-container>
  }
</ng-template>

<ng-template #firstStep>
  <div class="single-choice answer-container">
    <qa-selection-list
      [options]="roleOptions[edition]"
      labelKey="role"
      [(value)]="stepsSelectValues.firstStep.selectedValue"
      (selectionChange)="updateIsCustomValue('firstStep', $event?.value?.role)"
      [disabled]="disabled"
    ></qa-selection-list>

    @if (stepsSelectValues.firstStep.isCustomValue) {
    <div class="something-else-input">
      <input
        name="other-role"
        id="other-role"
        [(ngModel)]="stepsSelectValues.firstStep.customValue"
      />
    </div>
    }

    <div class="submit-button">
      <qa-button
        [isRaisedButton]="true"
        [disabled]="switchingStep || !stepsSelectValues.firstStep.selectedValue"
        [label]="'common.button.next' | translate"
        (submitted)="onRoleSubmit()"
      ></qa-button>
    </div>
  </div>
</ng-template>

<ng-template #firstIntermediateStep>
  <div class="guid-tour-step">
    <qa-button
      [label]="
        'onboarding.steps.wrongRegistered.button.deleteAccount' | translate
      "
      [isRaisedButton]="true"
      [disabled]="switchingStep"
      (submitted)="onDeleteAccount()"
    ></qa-button>
    <qa-button
      [label]="'onboarding.steps.wrongRegistered.button.continue' | translate"
      [disabled]="switchingStep"
      (submitted)="nextStep()"
    ></qa-button>
  </div>
</ng-template>

<ng-template #phoneNumberStep>
  <form class="additional-info-form">
    <mat-form-field appearance="outline">
      <mat-label>{{
        'onboarding.steps.additionalInfo.phoneNumber' | translate
      }}</mat-label>
      <input
        matInput
        placeholder="e.g. +49 176 000000000"
        [formControl]="phoneNumberControl"
        type="tel"
      />
      @if (phoneNumberControl.hasError('pattern')) {
      <mat-error>
        {{ 'onboarding.steps.additionalInfo.phoneNumberError' | translate }}
      </mat-error>
      }
    </mat-form-field>
    <qa-button
      [label]="'onboarding.next' | translate"
      [isRaisedButton]="true"
      [disabled]="switchingStep"
      [disabled]="
        phoneNumberControl.invalid || !phoneNumberControl.value.length
      "
      (submitted)="onPhoneNumberSubmit()"
    ></qa-button>
    <qa-button
      [label]="'onboarding.steps.additionalInfo.ratherSkip' | translate"
      (submitted)="nextStep()"
      [disabled]="switchingStep"
    ></qa-button>
  </form>
</ng-template>

<ng-template #secondStep>
  <div class="single-choice answer-container">
    <qa-selection-list
      [options]="qaKnowledgeSourceOptions"
      labelKey="source"
      [(value)]="stepsSelectValues.secondStep.selectedValue"
      (selectionChange)="
        updateIsCustomValue('secondStep', $event?.value?.source)
      "
      [disabled]="disabled"
    ></qa-selection-list>

    @if (stepsSelectValues.secondStep.isCustomValue) {
    <div class="something-else-input">
      <input
        name="other-source"
        id="other-source"
        [(ngModel)]="stepsSelectValues.secondStep.customValue"
      />
    </div>
    }

    <div class="submit-button">
      <qa-button
        [isRaisedButton]="true"
        [disabled]="
          switchingStep || !stepsSelectValues.secondStep.selectedValue
        "
        [label]="'common.button.next' | translate"
        (submitted)="onQaKnowledgeSourceSubmit()"
      ></qa-button>
    </div>
  </div>
</ng-template>

<!-- Hide step temporary -->
<!-- <ng-template #thirdStep>
  <div class="multiple-choice answer-container">
    @for (option of qaGoalsOptions; track option.amplitudeValue; let i = $index)
    {
    <mat-checkbox
      [disabled]="disabled"
      #checkbox
      [checked]="getIsGoalSelected(option)"
      (change)="onSelectQaGoals($event, option, i)"
      class="answer"
      color="primary"
    >
      {{ option.goal | translate }}
    </mat-checkbox>
    } @if (stepsSelectValues.thirdStep.isCustomValue) {
    <div class="something-else-input">
      <input
        name="other-goal"
        id="other-goal"
        [(ngModel)]="stepsSelectValues.thirdStep.customValue"
      />
    </div>
    }

    <div class="submit-button">
      <qa-button
        [isRaisedButton]="true"
        [disabled]="
          switchingStep || stepsSelectValues.thirdStep.selectedValue.length < 1
        "
        [label]="'common.button.next' | translate"
        (submitted)="onQaGoals()"
      ></qa-button>
    </div>
  </div>
</ng-template> -->

<ng-template #fourthStep>
  <div class="use-cases">
    <div class="use-case" (click)="activateUseCase(courseUseCase)">
      <qa-course-card [isOnboarding]="true"></qa-course-card>
    </div>
    <div class="use-case" (click)="activateUseCase(liveEventUseCase)">
      <qa-live-event-card [isOnboarding]="true"></qa-live-event-card>
    </div>
    <div class="use-case" (click)="activateUseCase(examUseCase)">
      <qa-exam-card [isOnboarding]="true"></qa-exam-card>
    </div>
  </div>
</ng-template>

<ng-template #fifthStep>
  <div class="guid-tour-step">
    <qa-button
      [label]="'onboarding.steps.guidedTour.button.exploreMyOwn' | translate"
      [disabled]="switchingStep"
      (submitted)="activeGuidTour()"
    ></qa-button>
    <qa-button
      [label]="'onboarding.steps.guidedTour.button.startTour' | translate"
      [isRaisedButton]="true"
      [disabled]="switchingStep"
      (submitted)="activeGuidTour(true)"
    ></qa-button>
  </div>
  <div class="progress-card-container">
    <div class="progress-card-header">
      {{ 'onboarding.steps.guidedTour.alreadyTakenFirstStep' | translate }}
    </div>
    <div class="progress-card-description">
      {{ `onboarding.steps.guidedTour.${this.stepsSelectValues.fourthStep.selectedValue?.amplitudeValue}.start` | translate }}
    </div>
    <qa-progress-card [progressCard]="cardData"></qa-progress-card>
  </div>
</ng-template>
